export function hexToRgba(hex: string, opacity: number): string {
  const cleanHex = hex.replace(/^#/, '')

  if (![3, 6].includes(cleanHex.length)) throw new Error('Неверный формат hex-цвета')

  const fullHex =
    cleanHex.length === 3
      ? cleanHex
          .split('')
          .map(ch => ch + ch)
          .join('')
      : cleanHex

  // Извлекаем RGB
  const r = parseInt(fullHex.slice(0, 2), 16)
  const g = parseInt(fullHex.slice(2, 4), 16)
  const b = parseInt(fullHex.slice(4, 6), 16)

  // Преобразуем прозрачность: если больше 1 — считаем, что это проценты
  const alpha = opacity > 1 ? opacity / 100 : opacity

  // Проверка диапазона
  if (alpha < 0 || alpha > 1) {
    throw new Error('Прозрачность должна быть от 0 до 1 или от 0 до 100 (%)')
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
